// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#loader[data-v-31f2c1d6]{position:fixed;width:100%;height:100vh;top:0;left:0;background:#f8f9fa;margin:0 auto;text-align:center;z-index:10000}#loader .loading-info[data-v-31f2c1d6]{position:relative;margin:calc(50vh - 105px) auto 0;width:290px;height:174px;font-size:16px;font-weight:700;color:#b1b8c4}.loading-info .load-text[data-v-31f2c1d6]{width:290px}.loading-info img[data-v-31f2c1d6]{width:290px;height:135px;margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
